@if (path) {
    <a class="internalLink" [routerLink]="normalizedPath">
        <span class="linkLabel" [ngClass]="{ isActive: !isActive }">{{ label ?? 'Link' }}</span>
    </a>
}
